import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Analytics, GlobalNotifications, Intent, Wizard } from '../Modules';
import { FloatingLabelInput as Input } from '../Elements';
import { graphql, commitMutation } from 'react-relay';

class NewPlaylist extends Component {
  static propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    openPlaylist: PropTypes.func.isRequired,
    trigger: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      title: ''
    };
    this.onOpen = this.onOpen.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.createPlaylist = this.createPlaylist.bind(this);
  }

  onOpen() {
    this.setState({ title: '' });
  }

  onTitleChange(e) {
    this.setState({ title: e.target.value });
  }

  onValidSubmit(model, resetForm, invalidateForm, successCb) {
    this.createPlaylist(model, successCb);
  }

  onInvalidSubmit() {
    GlobalNotifications.show({
      message: 'Unable to add playlist',
      intent: Intent.DANGER
    });
  }

  createPlaylist(playlist, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to add playlist',
        intent: Intent.DANGER
      });
    };
    const onCompleted = (response) => {
      if (successCb) successCb();
      this.props.openPlaylist(response.createPlaylist.new_playlist_edge.node.id);
      Analytics.trackEvent('created-playlist');
    };

    const mutation = graphql`
      mutation NewPlaylist_createPlaylistMutation(
        $input: CreatePlaylistInput!
      ) {
        createPlaylist(input: $input) {
          new_playlist_edge {
            node {
              id
              title
              description
              can_edit
              playlist_songs(first: 99999)
                @connection(key: "UserPlaylistContainer_playlist_songs") {
                edges {
                  node {
                    id
                  }
                }
              }
            }
          }
        }
      }
    `;

    const parentID = this.props.viewer.id;

    const configs = [
      {
        type: 'RANGE_ADD',
        parentID,
        edgeName: 'new_playlist_edge',
        connectionInfo: [
          {
            key: 'PlaylistsContainer_playlists',
            rangeBehavior: 'append'
          },
          {
            key: 'PlannerPlaylistContainer_playlists',
            rangeBehavior: 'append'
          },
          {
            key: 'MpTemplateContainer_playlists',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          title: playlist.title
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  render() {
    const { trigger } = this.props;
    const { title } = this.state;
    const content = () =>
      <div>
        <Input
          autoFocus
          name='title'
          onChange={this.onTitleChange}
          value={title}
          required
          label='Playlist Title'
          placeholder='Wedding Dance Hits'
          validationError='Title is required'
        />
      </div>;
    return (
      <div>
        <Wizard
          onOpen={this.onOpen}
          steps={[
            {
              component: content,
              title: 'Add Playlist',
              actions: {
                primary: {
                  content: 'Create Playlist',
                  disabled: title === '',
                  type: 'submit'
                }
              },
              formProps: {
                onValidSubmit: this.onValidSubmit,
                onInvalidSubmit: this.onInvalidSubmit
              }
            }
          ]}
          trigger={trigger}
        />
      </div>
    );
  }
}

export default NewPlaylist;



// WEBPACK FOOTER //
// ./webpack/components/App/NewPlaylist.js